import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

import '../assets/css/style2.css';
import '../assets/css/datepicker.min.css';
import '../assets/css/fancybox.min.css';
import '../assets/css/swiper2.min.css';
import '../assets/css/bootstrap.min.css';

import offersHeader from '../assets/images/aboutus/offers_header.webp';

const OFFER_API = 'https://3rey9w5wwi.execute-api.us-east-1.amazonaws.com/oryzadev/offer/';
const HOTEL_NAME = 'kent-cottage-nuwara-eliya';

const formatOfferDate = (value) => {
  if (!value) return '';
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return value;
  return parsed.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
};

const Offer = () => {
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const navbar = document.querySelector('.navbarzzz');
      if (navbar) {
        navbar.style.backgroundColor = window.scrollY > 0 ? '#722628' : 'transparent';
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const controller = new AbortController();

    const loadOffers = async () => {
      try {
        const response = await fetch(OFFER_API, { signal: controller.signal });
        if (!response.ok) {
          throw new Error('Failed to load offers');
        }

        const payload = await response.json();
        const items = Array.isArray(payload) ? payload : payload?.data || [];
        const activeHotelOffers = items.filter(
          (item) => item.hotelName === HOTEL_NAME && item.status === 'active'
        );

        setOffers(activeHotelOffers);
        setError(false);
      } catch (err) {
        if (err.name !== 'AbortError') {
          setError(true);
          setOffers([]);
        }
      } finally {
        if (!controller.signal.aborted) {
          setLoading(false);
        }
      }
    };

    loadOffers();
    return () => controller.abort();
  }, []);

  return (
    <div className="example">
      <Helmet>
        <title>Offers | Kent Cottage Nuwara Eliya | Oryza Leisure</title>
        <meta name="author" content="" />
        <meta name="description" content="Beautiful Luxury and Cosy stay at Kent Cottage Nuwara-Eliya" />
        <meta name="keywords" content="hotel, room, restaurant, events, pool, nightlife, bed, matras, balcony, vacation, honeymoon, suit, premium, deluxe, penthouse, VIP" />
      </Helmet>

      <div className="cursor js-cursor"></div>

      <Navbar />

      <main id="main">
        <header className="page-header" style={{ backgroundImage: `url(${offersHeader})` }}>
          <div className="container">
            <h1>Offers</h1>
            <p>Enjoy more, Spend less</p>
          </div>
          <div className="scroll-down"></div>
        </header>

        <section className="content-section kentbg offer-section">
          <div className="container">
            {loading && (
              <p className="offer-status-message">Loading current offers...</p>
            )}

            {!loading && error && (
              <p className="offer-status-message">Unable to load offers right now. Please try again later.</p>
            )}

            {!loading && !error && offers.length === 0 && (
              <p className="offer-status-message">There are no offers at the moment!</p>
            )}

            {!loading && !error && offers.length > 0 && (
              <div className="row offer-grid">
                {offers.map((item) => (
                  <div className="col-12 col-md-6 col-xl-4 offer-grid-item" key={item._id || item.title}>
                    <article className="offer-card">
                      <figure className="offer-card-media">
                        <img src={item.image} alt={item.title || 'Kent Cottage offer'} />
                      </figure>
                      <div className="offer-card-body">
                        {item.date && <div className="offer-card-date">{formatOfferDate(item.date)}</div>}
                        <h3>{item.title}</h3>
                        <p>{item.description}</p>
                      </div>
                    </article>
                  </div>
                ))}
              </div>
            )}
          </div>
        </section>

        <Footer />
      </main>

      <style>
        {`
          .page-header {
            position: relative;
            height: 60vh;
            background-size: cover;
            background-position: center;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: left;
            color: white;
          }

          .page-header .container {
            padding: 20px;
            max-width: 1200px;
            margin: 0 auto;
          }

          .page-header .container h1 {
            width: 100%;
            display: block;
            font-size: 3.5rem;
            font-weight: 300;
            margin-bottom: 10px;
            line-height: 1.2;
            font-family: "Argesta Display";
            text-indent: 130px;
          }

          .page-header .container p {
            font-size: 1.5rem;
            font-weight: 300;
            margin: 0;
            line-height: 1.5;
            text-indent: 130px;
          }

          .scroll-down {
            position: absolute;
            bottom: 20px;
            width: 2px;
            height: 40px;
            background: white;
            margin: 0 auto;
            left: 50%;
            transform: translateX(-50%);
          }

          .offer-section {
            padding: 80px 0 100px;
          }

          .offer-status-message {
            font-size: 30px;
            text-align: center;
            font-weight: 700;
            letter-spacing: 0;
            color: #ffffff;
            margin: 0;
          }

          .offer-grid {
            margin-left: -15px;
            margin-right: -15px;
          }

          .offer-grid-item {
            display: flex;
            padding-left: 15px;
            padding-right: 15px;
            margin-bottom: 36px;
          }

          .offer-card {
            width: 100%;
            display: flex;
            flex-direction: column;
            background: transparent;
          }

          .offer-card-media {
            width: 100%;
            margin: 0;
            overflow: hidden;
          }

          .offer-card-media img {
            width: 100%;
            height: 260px;
            object-fit: cover;
            display: block;
          }

          .offer-card-body {
            width: calc(100% - 28px);
            background: #ecdfd7;
            margin-top: -42px;
            margin-left: 28px;
            position: relative;
            z-index: 1;
            padding: 24px 28px 28px;
            flex: 1;
            display: flex;
            flex-direction: column;
          }

          .offer-card-date {
            width: 100%;
            font-size: 14px;
            font-weight: 600;
            color: #280909;
            letter-spacing: 1px;
            text-transform: uppercase;
            margin-bottom: 8px;
          }

          .offer-card-body h3 {
            width: 100%;
            font-size: 32px;
            font-family: "Argesta Display";
            font-weight: 500;
            color: #722628;
            line-height: 1.2;
            margin: 0 0 12px;
          }

          .offer-card-body p {
            color: #280909;
            font-size: 16px;
            line-height: 1.6;
            margin: 0;
          }

          @media (max-width: 1199px) {
            .offer-card-body h3 {
              font-size: 28px;
            }
          }

          @media (max-width: 768px) {
            .page-header {
              height: 60vh;
              background-size: cover !important;
              background-position: center;
            }

            .page-header .container h1 {
              font-size: 1.8rem;
              line-height: 1.2;
              text-indent: 50px;
            }

            .page-header .container p {
              font-size: 0.9rem;
              line-height: 1.5;
              text-indent: 50px;
            }

            .offer-section {
              padding: 48px 0 72px;
            }

            .offer-status-message {
              font-size: 22px;
              padding: 0 12px;
            }

            .offer-card-media img {
              height: 210px;
            }

            .offer-card-body {
              width: 100%;
              margin-left: 0;
              margin-top: 0;
              padding: 20px;
            }

            .offer-card-body h3 {
              font-size: 24px;
            }

            .offer-card-body p {
              font-size: 15px;
            }
          }

          @media (max-width: 480px) {
            .offer-card-media img {
              height: 180px;
            }

            .offer-grid-item {
              margin-bottom: 24px;
            }
          }
        `}
      </style>
    </div>
  );
};

export default Offer;
